import React from "react";
import { Col, Row } from "react-bootstrap";
import Instagram from "../../Home/Instagram/Instagram";
import NavBar2 from "../../Shared/NavBar2/NavBar2";
import "./About.css";
import Fade from "react-reveal/Fade";
const About = () => {
  return (
    <div>
      <NavBar2 />
      <div className="about margin">
        <div className="about1">
          <h2 className="text-dark">About Us</h2>
        </div>
      </div>
      <div className="container">
        <Row lg={2} sm={12} className="mt-5">
          <Fade left>
            <Col sm={12}>
              <div className="img-hover-zoom">
                <img
                  className="img-fluid"
                  src="https://i.ibb.co/JQphztr/instagram9.jpg"
                  alt=""
                />
              </div>
            </Col>
          </Fade>
          <Fade right>
            <Col sm={12} className="mt-5">
              <span>Photographer</span>
              <h3>Justin Lisiakir</h3>
              <p className="details">
                We believe in a world where you have total freedom to be you,
                without judgement. To experiment. To express yourself. To be
                brave and grab life as the extraordinary adventure it is. So we
                make sure everyone has an equal chance to discover all the
                amazing things they’re capable of – no matter who they are,
                where they’re from or what looks they like to boss. We exist to
                give you the confidence to be whoever you want to be
              </p>
            </Col>
          </Fade>
        </Row>

        <Row lg={2} className="mt-5">
          <Fade left>
            <Col sm={12} className="mt-5">
              <span>Sales agent</span>
              <h3>Alex Barnder</h3>
              <p className="details">
                We believe in a world where you have total freedom to be you,
                without judgement. To experiment. To express yourself. To be
                brave and grab life as the extraordinary adventure it is. So we
                make sure everyone has an equal chance to discover all the
                amazing things they’re capable of – no matter who they are,
                where they’re from or what looks they like to boss. We exist to
                give you the confidence to be whoever you want to be
              </p>
            </Col>
          </Fade>
          <Fade right>
            <Col sm={12}>
              <div className="img-hover-zoom">
                <img
                  className="img-fluid"
                  src="https://i.ibb.co/LRCx4m0/instagram10.jpg"
                  alt=""
                />
              </div>
            </Col>
          </Fade>
        </Row>
        <Row lg={2} className="mt-5">
          <Fade left>
            <Col sm={12}>
              <div className="img-hover-zoom">
                <img
                  className="img-fluid"
                  src="https://i.ibb.co/4gB2Mv5/instagram8.jpg"
                  alt=""
                />
              </div>
            </Col>
          </Fade>

          <Fade right>
            <Col sm={12} className="mt-5">
              <span>Web Designer</span>
              <h3>Angelika Hess</h3>
              <p className="details">
                We believe in a world where you have total freedom to be you,
                without judgement. To experiment. To express yourself. To be
                brave and grab life as the extraordinary adventure it is. So we
                make sure everyone has an equal chance to discover all the
                amazing things they’re capable of – no matter who they are,
                where they’re from or what looks they like to boss. We exist to
                give you the confidence to be whoever you want to be
              </p>
            </Col>
          </Fade>
        </Row>
        <Row lg={2} className="mt-5 mb-5">
          <Fade left>
            <Col sm={12} className="mt-5">
              <span>Marketing Staff</span>
              <h3>Angelika Hessas</h3>
              <p className="details">
                We believe in a world where you have total freedom to be you,
                without judgement. To experiment. To express yourself. To be
                brave and grab life as the extraordinary adventure it is. So we
                make sure everyone has an equal chance to discover all the
                amazing things they’re capable of – no matter who they are,
                where they’re from or what looks they like to boss. We exist to
                give you the confidence to be whoever you want to be
              </p>
            </Col>
          </Fade>
          <Fade right>
            <Col sm={12} className="mt-5">
              <div className="img-hover-zoom">
                <img
                  className="img-fluid"
                  src="https://i.ibb.co/BGYMBfY/instagram7.jpg"
                  alt=""
                />
              </div>
            </Col>
          </Fade>
        </Row>
      </div>
      {/* another section */}
      {/* <div className="about-banner text-light mt-5 mb-5 p-5 ">
        <h5 className=" text-center m-5">Reasons to shop with us</h5>
        <div className="container">
          <Row lg={3} className="">
            <Col sm={12}>
              <h6>24/7 FRIENDLY SUPPORT</h6>
              <span>
                Our support team always ready for you to 7 days a week
              </span>
            </Col>
            <Col sm={12}>
              <h6>7 DAYS EASY RETURN</h6>
              <span>
                Product any fault within 7 days for an immediately exchange
              </span>
            </Col>
            <Col sm={12}>
              <h6>QUALITY GUARANTEED</h6>
              <span>
                If your product aren't perfect return then for a full refund
              </span>
            </Col>
          </Row>
        </div>
      </div> */}
      <Instagram />
    </div>
  );
};

export default About;
